import { schema } from "normalizr";

const PermissionByRoleSchema = new schema.Entity("permissionByRoles");
const PermissionByRoleArraySchema = new schema.Array(PermissionByRoleSchema);

export { PermissionByRoleSchema, PermissionByRoleArraySchema };